import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdateAccountGroupsShareRequestModel, UpdateAccountGroupsShareResponseModel } from "@/features/accounts/account-group/services/update-account-groups-share-model";

export class UpdateAccountGroupsShareApi {
  /**
   * 口座グループ共有メンバー更新
   */
  public updateAccountGroupsShare = async (
    param: UpdateAccountGroupsShareRequestModel
  ): Promise<UpdateAccountGroupsShareResponseModel> => {
    const path = `/api/accountgroups/share`;
    const res = await ApiClient.instance.put<UpdateAccountGroupsShareResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
